const formatValidOuterLink = (link: string) =>
  link?.startsWith("https://") ? link : `https://${link}`;

export default formatValidOuterLink;
